export default __webpack_public_path__ + "static/media/stillunsure.bc2a9d03.svg";